import React, { useState } from 'react';
import { motion } from 'framer-motion';

import { images } from '../../../constants';
import { FaInstagram } from 'react-icons/fa';
import { client } from '../../../client';
import './Footer.css';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div id="contact" className="app__container app__whitebg">
      <div className="app__wrapper app__flex">
        <motion.div
          whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
          transition={{ duration: 0.5 }}
          className="app__footer app__flex"
        >
          <h2 className="head-text">Let's Build a Better "Say Yes TN".<br /> Share Your Thoughts OR Report an Issue.</h2>

          <div className="app__footer-cards">
            <div className="app__footer-card ">
              <img src={images.email} alt="email" />
              <a href="mailto:mbarkiamidou@gmail.com" className="p-text">mbarkiamidou@gmail.com</a>
            </div>
            <div className="app__footer-card">
              <img src={images.mobile} alt="phone" />
              <a href="tel:+216 22654535" className="p-text">+216 22654535</a>
            </div>
          </div>
          {!isFormSubmitted ? (
            <div className="app__footer-form app__flex">
              <div className="app__flex">
                <input className="p-text" type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
              </div>
              <div className="app__flex">
                <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
              </div>
              <div>
                <textarea
                  className="p-text"
                  placeholder="Your Message"
                  value={message}
                  name="message"
                  onChange={handleChangeInput}
                />
              </div>
              <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
            </div>
          ) : (
            <div>
              <h3 className="head-text">
                Thank you for getting in touch!
              </h3>
            </div>
          )}
          <div className="social-container">
            <div className="app__social">
              <a href="https://www.instagram.com/mbarki_amidou/" target="_blank" rel="noreferrer">
                <div className="InstaIcon">
                  <FaInstagram />
                </div>
              </a>
            </div>
            <div className="copyright">
              <p className="p-text" style={{ color: 'white' }}>@2025 <b><a href="https://mbarkiamidou.netlify.app/" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'purple' }}>Amidou</a></b></p>
              <p className="p-text" style={{ color: 'white' }}>All rights reserved</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Footer;
